import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    banner: {
        id: 'banner.no_services_countries',
        defaultMessage:
            'Please note Broker does not offer services in some countries. Please <a data-pointer="no_service_countries_link" target="_blank" href="#" rel="noopener noreferrer">click here</a> to find out more.',
    },
})
